export const blockIconsPlacesRoomService = (
	<span className='material-symbols-outlined'>room_service</span>
);
